import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DateTime } from "luxon";
import { Helmet } from "react-helmet";
import ReactPlayer from "react-player";
import { scroller } from "react-scroll";
import { FacebookShareButton, TwitterShareButton } from "react-share";

import Localization from "../../localization";
import Button from "../../components/button";
import IconClose from "../../components/icons/close";
import IconSpinner from "../../components/icons/spinner";
import IconLogo from "../../components/icons/logo";
import Item from "../Blog/item";
import Gallery from "../../components/gallery";
import { loadArticle, loadRelatedArticles } from "../../redux/actions/blog";
import { getArticle, getRelatedArticles } from "../../redux/selectors/blog";
import { getUrl, fixExternalLinks } from "../../utils/helper";

class Article extends Component {
    componentDidMount() {
        this._setup();
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.slug !== prevProps.match.params.slug) {
            this._setup();
        }
    }

    _setup() {
        this.props.loadArticle(this.props.match.params.slug);
        this.props.loadRelatedArticles(this.props.match.params.slug);

        scroller.scrollTo("elementName", {
            duration: 700,
            smooth: true,
            containerId: "containerId",
        });
    }

    _renderRelated() {
        const { related, article } = this.props;

        if (!related || related.length <= 0) return null;

        return (
            <div
                style={{ backgroundColor: article.tag.color }}
                className="grid pt-60 px-16 xl:px-50 pb-60 md:grid-cols-2 xl:grid-cols-3 gap-x-30 gap-y-50 xl:gap-y-60"
            >
                {related.map((item) => (
                    <Item key={item.id} item={item} related />
                ))}
            </div>
        );
    }

    _renderSection(section) {
        if (section.layout === "text") {
            return (
                <div key={section.key} className="flex mt-30 xl:mt-60">
                    <div className="xl:w-2/12" />
                    <div className="xl:w-10/12">
                        <div
                            key={section.key}
                            className="article-body xl:w-9/12 leading-tight article-break-word text-17 xl:text-23 text-blue"
                            dangerouslySetInnerHTML={{
                                __html: fixExternalLinks(
                                    section.attributes.text
                                ),
                            }}
                        />
                    </div>
                </div>
            );
        } else if (section.layout === "video") {
            return (
                <div
                    key={section.key}
                    className="flex justify-end mt-30 xl:mt-60"
                >
                    <div className="xl:w-8/12 w-full relative">
                        <div className="aspect-ratio-16/9 w-full relative">
                            <div className="absolute w-full h-full">
                                <ReactPlayer
                                    width="100%"
                                    height="100%"
                                    controls
                                    url={section.attributes.embed}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="xl:w-2/12" />
                </div>
            );
        } else if (section.layout === "gallery") {
            return (
                <div
                    key={section.key}
                    className="flex justify-end mt-30 xl:mt-60"
                >
                    <Gallery
                        data={section.attributes.gallery}
                        autoHeight={true}
                        padding={"xl:mr-60"}
                    />
                    <div className="xl:w-1/12" />
                </div>
            );
        } else if (section.layout === "image") {
            return (
                <div
                    key={section.key}
                    className="flex justify-end mt-30 xl:mt-60"
                >
                    <Gallery
                        caption={section.attributes.caption}
                        autoHeight={true}
                        padding={"xl:mr-60"}
                        data={[section.attributes.image]}
                    />
                    <div className="xl:w-1/12" />
                </div>
            );
        }

        return null;
    }

    _renderShare() {
        const { locale, location } = this.props;

        return (
            <div className="flex mt-30 xl:mt-60">
                <div className="xl:w-2/12" />
                <div className="xl:w-10/12">
                    <div className="xl:w-9/12" />
                    <div className="xl:flex">
                        <div className="flex">
                            <p className="font-bold font-judge text-17 xl:text-23">
                                {Localization[locale].home.blog_share}
                            </p>
                            <div className="flex ml-40 xl:ml-50">
                                <FacebookShareButton
                                    className="mr-20"
                                    url={window.origin + "" + location.pathname}
                                    title={"Facebook"}
                                >
                                    <p
                                        className={
                                            "text-17 font-bold xl:text-23 underline text-blue"
                                        }
                                    >
                                        Facebook
                                    </p>
                                </FacebookShareButton>
                                <TwitterShareButton
                                    url={window.origin + "" + location.pathname}
                                    title={"Twitter"}
                                >
                                    <p
                                        className={
                                            "text-17 font-bold xl:text-23 underline text-blue"
                                        }
                                    >
                                        Twitter
                                    </p>
                                </TwitterShareButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { article, locale, history } = this.props;

        const className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 z-20";

        if (!article)
            return (
                <div className={className}>
                    <Helmet>
                        <body className="modal-open" />
                    </Helmet>
                    <div className="bg-grey flex flex-col items-center justify-center w-full">
                        <IconSpinner className="animate-spin w-20 xl:w-32 h-20 xl:h-32 text-blue" />
                        <IconLogo
                            className={
                                "w-140 xl:w-208 h-30 xl:h-46 mt-40 text-blue"
                            }
                        />
                    </div>
                </div>
            );

        return (
            <div className={className}>
                <Helmet>
                    <body className="modal-open" />
                </Helmet>
                <div
                    id="containerId"
                    className="bg-grey overflow-y-auto w-full"
                >
                    <div
                        name="elementName"
                        className="pt-30 xl:pt-40 pb-80 px-16 xl:px-50"
                    >
                        <div className="hidden xl:flex justify-end">
                            <Button
                                icon={
                                    <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                }
                                onClick={() => {
                                    history.goBack();
                                }}
                                style={"w-70"}
                            />
                        </div>
                        <div className="flex relative xl:mt-40">
                            <div className="xl:w-2/12" />
                            <div className="xl:w-10/12">
                                <p
                                    style={{ color: article.tag.color }}
                                    className="font-judge font-bold text-30 uppercase"
                                >
                                    {article.tag.name}
                                </p>
                                <p
                                    style={{ color: article.tag.color }}
                                    className="font-judge font-bold text-30 uppercase"
                                >
                                    {DateTime.fromISO(
                                        article.publish_date
                                    ).toLocaleString(DateTime.DATE_MED)}
                                </p>
                                <h1 className="font-bold xl:w-9/12 mt-40 text-30 xl:text-60 text-blue">
                                    {article.title}
                                </h1>
                                <div className="xl:hidden absolute right-0 top-0">
                                    <Button
                                        icon={
                                            <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                        }
                                        onClick={() => {
                                            history.goBack();
                                        }}
                                        style={"w-50"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex mt-30 xl:mt-60">
                            <div className="xl:w-2/12" />
                            <div className="xl:w-10/12">
                                <p className="font-bold xl:w-9/12 text-17 xl:text-23 text-blue">
                                    {article.summary}
                                </p>
                            </div>
                        </div>
                        <div className="article-body">
                            {article.body.map((section) =>
                                this._renderSection(section)
                            )}
                        </div>
                        {this._renderShare()}
                        <div className="hidden xl:flex mt-30 xl:mt-40">
                            <div className="xl:w-2/12" />
                            <div className="xl:w-10/12">
                                <div className="xl:w-9/12" />
                                <div className="xl:flex">
                                    <Button
                                        text={
                                            Localization[locale].home.blog_back
                                        }
                                        textStyle={
                                            "font-bold text-20 xl:text-17 z-10 transition hover-hover:group-hover:text-white text-blue"
                                        }
                                        backgroundColor={"bg-grey"}
                                        wrapperStyle={"px-20"}
                                        to={getUrl("bookmarks")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {this._renderRelated()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    locale: state.app.locale,
    article: getArticle(state, props.match.params.slug),
    isLoading: state.blog.isLoading,
    related: getRelatedArticles(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadArticle,
            loadRelatedArticles,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Article);
